import styled from 'styled-components';

export const SearchContainer = styled.div`
  @media screen and (max-width: 512px) {
    padding: 0 8px;
  }
`;

export const MarkAndModelContainer = styled.div`
  width: 100%;

  .wrapper {
    display: flex;
    max-width: 880px;

    @media screen and (max-width: 1080px) {
      max-width: inherit;
      justify-content: space-between;
    }
  }

  .brand-item,
  .model-item,
  .brand,
  .model {
    flex: 1;
  }

  @media screen and (max-width: 1080px) {
    .brand-item,
    .model-item {
      flex: inherit;
    }
    .brand,
    .model {
      width: 100%;
    }
  }
`;

export const LinksTab = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  .link {
    display: inline-block;
    padding: 22px 30px;
    text-decoration: none;
    color: ${({ theme }) => theme.colors.color_tab_hover_text};
    cursor: pointer;
    border-radius: 10px 10px 0 0;

    &:hover {
      color: ${({ theme }) => theme.colors.color_dark};
    }

    @media (max-width: 1024px) {
      padding: 18px;
    }
  }

  .selected {
    background: ${({ theme }) => theme.colors.gallery};
    color: ${({ theme }) => theme.colors.limedSpruce};
  }

  .plain-text-container {
    margin-left: 25px;
  }

  @media screen and (max-width: 850px) {
    display: none;
  }
`;

export const TabsContent = styled.div`
  background: ${({ theme }) => theme.colors.gallery};
  box-shadow: 0 2px 1px rgba(0, 0, 0, 0.14);
  border-radius: 0 0 10px 10px;

  @media screen and (max-width: 768px) {
    border-radius: 10px 0 10px 10px;
  }

  @media screen and (max-width: 320px) {
    border-radius: 10px;
  }
`;

export const SearchBtn = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 20px;

  .instructions {
    display: flex;
    margin-right: auto;
  }

  .instructions-mobile {
    display: none;
  }

  .actions {
    display: flex;
    justify-content: flex-end;
    margin-left: auto;
  }

  .actions-wrapper {
    display: flex;
    flex-wrap: wrap-reverse;
    align-self: flex-end;
    align-items: center;
  }

  .reset-container {
    display: flex;
    align-items: center;
  }

  .link-wrapper {
    flex-shrink: 0;
    display: flex;
    margin-right: 26px;

    .youtube-icon,
    .docs-icon {
      margin-right: 8px;
    }

    .favorite-icon {
      margin-right: 4px;
    }

    &:hover {
      .youtube-icon {
        svg path:first-child {
          fill: ${(props) => props.theme.colors.monza};
        }
      }

      .docs-icon {
        svg path {
          fill: ${(props) => props.theme.colors.primary};
        }
      }

      .favorite-icon {
        svg path {
          fill: ${(props) => props.theme.colors.color_blue_hover};
        }
      }
    }
  }

  .favorite-link {
    font-size: ${({ theme }) => theme.fontSize.sm};
    text-decoration: none;

    &,
    &:active,
    &:visited {
      color: ${({ theme }) => theme.colors.primary};
    }

    &:hover {
      color: ${({ theme }) => theme.colors.color_blue_hover};
    }
  }

  @media screen and (max-width: 1080px) {
    .instructions {
      display: none;
    }

    .instructions-mobile {
      display: flex;
    }
  }

  @media screen and (max-width: 768px) {
    align-items: flex-start;

    .instructions-mobile {
      padding: 13px 0;
    }

    .link-wrapper {
      margin-right: 10px;
    }
  }

  @media screen and (max-width: 600px) {
    .actions-wrapper {
      width: min-content;
      justify-content: center;

      .reset-container {
        margin-top: 20px;
      }
    }
  }

  @media screen and (max-width: 600px) {
    .instructions-mobile {
      display: none;
    }

    .actions-wrapper {
      width: 100%;
      flex-direction: column;
    }

    .actions {
      width: 100%;

      & .btn > button {
        width: 100%;
        & > button {
          width: 100%;
        }
      }

      .reset-container {
        justify-content: center;
        order: 2;
      }

      .btn {
        order: 1;
      }
    }
  }

  @media screen and (max-width: 320px) {
    .actions-wrapper .btn {
      width: 100%;
    }
  }
`;

export const Reset = styled.span`
  color: ${({ theme }) => theme.colors.regent};
  font-size: 12px;
  border-bottom: 1px dashed;
  cursor: pointer;
  margin: 0 20px;
  white-space: nowrap;

  &:hover {
    color: ${({ theme }) => theme.colors.color_blue};
    border-bottom: 1px solid;
  }
`;

export const CabinetAndFormButtonContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;

  @media (max-width: 769px) {
    //display: none;
  }

  .button-form {
    margin-left: 32px;

    @media (max-width: 1024px) {
      margin-left: 20px;
    }
  }
`;
